import { NumericReleaseResponseDto, NumericReleasesApi } from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'
import { Event, IEvent, IQueryHandler, IQueryMessage } from '@tom-ui/utils'

export class GetNumericReleaseByIdQuery implements IQueryMessage {
  static type = 'GetNumericReleaseByIdQuery'
  type = GetNumericReleaseByIdQuery.type

  constructor(public id: number) {}

  getKey = () => {
    return JSON.stringify(this)
  }
}

const httpClient = createApiClient(NumericReleasesApi)

export const getNumericReleaseByIdQueryHandler: IQueryHandler<
  GetNumericReleaseByIdQuery,
  IEvent<NumericReleaseResponseDto>
> = async query => {
  const { data } = await httpClient.getById(query.id)

  return new Event(GetNumericReleaseByIdQuery.type, data)
}
